var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Usuarios"}},[_c('b-tabs',[_c('b-tab',{attrs:{"lazy":"","title":"Usuarios Activos"}},[_c('UsuariosActivos')],1),_c('b-tab',{attrs:{"lazy":"","title":"Usuarios Inactivos"}},[_c('UsuariosInactivos')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }